import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';

export interface ISelfAlertIconDetailsData {
  icon: string;
  color: string;
}

export interface ISelfAlertIconDetailsAPIData {
  nk: string;
  rank: number;
  display_in_menu: boolean;
  icon: string;
  icon_color: string;
  is_in_beta: boolean;
  name: string;
  url: string;
  is_new: boolean;
}

export type SelfAlertIconDetailsModel = ITypedModel<ISelfAlertIconDetailsData>;

angular.module('capability-ng-priority-feed').factory(
  'ngSelfAlertIconDetailsModel',
  () =>
    new Model<ISelfAlertIconDetailsData>({
      icon: 'waving_hand',
      color: 'green'
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/models/self_alert_icon_details_model.ts